import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './ServiceDetail.css';
import MoveInImg from './moveinout.png';

const MoveInMoveOut = () => {
  const { t } = useLanguage();

  return (
    <div className="service-detail-page">
      <Navbar />

      <section className="service-hero">
        <div className="container">
          <h1>{t('services.moveInMoveOut.title', 'Move-in/Move-out Cleaning Services')}</h1>
          <p>{t('services.moveInMoveOut.subtitle', 'Complete deep cleaning for your relocation')}</p>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-detail-content">
            <div className="service-detail-image">
              <img src={MoveInImg} alt="Move-in/Move-out Cleaning" />
            </div>

            <div className="service-detail-text">
              <h2>{t('services.moveInMoveOut.heading', 'Comprehensive Relocation Cleaning')}</h2>
              <p>
                {t('services.moveInMoveOut.description', 'Moving can be stressful, but cleaning doesn\'t have to be. Our move-in/move-out cleaning services ensure your new home is move-in ready or that you leave your old place in pristine condition. We provide comprehensive deep cleaning that covers every detail, giving you peace of mind during your transition.')}
              </p>

              <h3>{t('services.moveInMoveOut.whatWeInclude', 'What We Include')}</h3>
              <ul className="service-features">
                <li>{t('services.moveInMoveOut.features.kitchen', 'Complete kitchen deep clean including inside all appliances')}</li>
                <li>{t('services.moveInMoveOut.features.bathroom', 'Bathroom sanitization and detailed scrubbing')}</li>
                <li>{t('services.moveInMoveOut.features.floors', 'All floors vacuumed, mopped, and polished')}</li>
                <li>{t('services.moveInMoveOut.features.windows', 'Window cleaning inside and out')}</li>
                <li>{t('services.moveInMoveOut.features.baseboards', 'Baseboard and door frame cleaning')}</li>
                <li>{t('services.moveInMoveOut.features.lights', 'Light fixtures and ceiling fan cleaning')}</li>
                <li>{t('services.moveInMoveOut.features.cabinets', 'Inside cabinet and closet cleaning')}</li>
                <li>{t('services.moveInMoveOut.features.walls', 'Wall spot cleaning and touch-ups')}</li>
                <li>{t('services.moveInMoveOut.features.blinds', 'Blinds and window sills cleaning')}</li>

              </ul>

              <h3>{t('services.moveInMoveOut.serviceOptions', 'Service Options')}</h3>
              <div className="service-options">
                <div className="service-option-card">
                  <h4>{t('services.moveInMoveOut.moveOut.title', 'Move-out Cleaning')}</h4>
                  <p>{t('services.moveInMoveOut.moveOut.description', 'Perfect for tenants who need to meet lease requirements or homeowners preparing to sell. We ensure you get your security deposit back.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.moveInMoveOut.moveIn.title', 'Move-in Cleaning')}</h4>
                  <p>{t('services.moveInMoveOut.moveIn.description', 'Start fresh in your new home with a comprehensive deep clean. We\'ll make sure every surface is sanitized and ready for your belongings.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.moveInMoveOut.fullService.title', 'Full Service')}</h4>
                  <p>{t('services.moveInMoveOut.fullService.description', 'Complete cleaning for both your old and new property, ensuring a smooth transition from one home to another.')}</p>
                </div>
              </div>

              <h3>{t('services.moveInMoveOut.whyChoose', 'Why Choose Our Move-in/Move-out Service?')}</h3>
              <p>
                {t('services.moveInMoveOut.whyChooseText', 'We understand the importance of leaving a property in excellent condition or starting fresh in a new space. Our detailed cleaning checklist ensures nothing is missed, and we work efficiently to complete the job on time. We\'re familiar with landlord requirements and can help ensure you meet all lease obligations. Our team uses professional-grade equipment and eco-friendly products to leave your property spotless and ready for the next chapter. We\'re fully insured and can provide cleaning receipts for your records.')}
              </p>

              <div className="service-cta">
                <Link to="/contact" className="btn btn-primary">{t('services.getQuote', 'Get a Quote')}</Link>
                <Link to="/" className="btn btn-secondary">{t('services.backToServices', 'Back to Services')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MoveInMoveOut;
